export const filters = [
  {
    filterName: 'isActive',
    items: [{ value: 'active' }, { value: 'inactive' }, { value: 'all' }],
  },
];
